var _module = require('../../components/module.js');
var config = require('config');
var _ = require('lodash');
var parseAddress = require('parse-address');

require('../utils');

_module.service('addressDeduplicationService', [
    '$log',
    '$utils',

    function addressDeduplicationService($log, $utils) {
        return {
            normalizeStreetType: function normalizeStreetType(streetType) {
                if (angular.isUndefined(streetType) || streetType == null) {
                    return '';
                }
                if (streetType.toLowerCase().match('av') != null) {
                    return 'Ave';
                } else if (streetType.toLowerCase().match('dr') != null) {
                    return 'Dr';
                } else if ((streetType.toLowerCase().match('cir') != null)
                    || (streetType.toLowerCase().match('cr') != null)) {
                    return 'Circle';
                } else if (streetType.toLowerCase().match('pl') != null) {
                    return 'Place';
                } else if (streetType.toLowerCase().match('st') != null) {
                    return 'St';
                } else {
                    return streetType;
                }
            },

            parseAndNormalizeAddress: function parseAndNormalizeAddress(address) {
                var formatted;
                var parts = parseAddress.parseLocation(address);
                if(parts === null) {
                    formatted = address;
                } else {
                    parts.type = this.normalizeStreetType(parts.type);
                    var formattedParts = [];
                    formattedParts.push(parts.number);
                    formattedParts.push(parts.street);
                    formattedParts.push(parts.type);
                    formattedParts.push(parts.sec_unit_num);
                    formattedParts.push(parts.city);
                    formattedParts.push(parts.state);
                    formattedParts.push(parts.zip);
                    formatted = formattedParts.join('-');
                }
                formatted = formatted.replace(/[^A-Z0-9]/ig, '').toLowerCase();
                return formatted;
            }
        };
    }
]);
